import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { createCognosSession } from '../../../../api/Reporting/createCognosSession.api';
import { openDashboard } from '../../../../api/Reporting/openCognosDashboard.api';
import CognosApi from '../../../../assets/js/cognosApi';
import {
	getReportsById,
	setLoading,
} from '../../../../redux/reporting/actions';
import styles from './ReportCategory.module.scss';
import ReportCategoryItem from './ReportCategoryItem/ReportCategoryItem';
import dashboardSpec from '../../../../assets/data/dashboardSpec';
import { createDashboard } from '../../../../api/Reporting/createCognosDashboard.api';
import { getCsvUrl } from '../../../../api/Reporting/getCsvUrl.api';
import { getJsonTableColumn } from '../../../../api/Reporting/getJsonTableColumn.api';
import Loading from '../../../layout/loading/Loading';
import * as PROJECT_CODE from '../../../../constants/projectCode';
import { generateCsv } from '../../../../api/Reporting/generateCsv.api';
import firebase from '../../../../lib/firebase.prod';
import dayjs from 'dayjs';
import getJson from '../../../../assets/data/dashboardSpec';

const ReportCategory = ({
	title,
	categoryId,
	reports,
	setLoading,
	setCognosApi,
	setDashboardAPI,
	setReportUniqueName,
	setReportTitle,
	setReportDbIndex,
	search,
}) => {
	const [filteredReports, setFilteredReports] = useState(reports[categoryId]);

	useEffect(() => {
		setFilteredReports(reports[categoryId]);
	}, [reports]);

	useEffect(() => {
		console.log('filterered', filteredReports);
	}, [filteredReports]);

	//search functionality
	useEffect(() => {
		const filtered = reports[categoryId]?.filter((report) =>
			report?.name?.toLowerCase().includes(search?.toLowerCase())
		);
		setFilteredReports(filtered);
	}, [search]);

	const handleGenerateReport = async (reportName, index, reportTitle) => {
		console.log('Running handleGenerateReport... ', index, reportName);
		setLoading(true);
		setReportDbIndex(index);
		var currentUser = firebase.auth().currentUser.uid;
		var unixTime = dayjs().unix();
		var uniqueFileName = `${reportName}_${currentUser}_${unixTime}`;

		setReportUniqueName(uniqueFileName);
		setReportTitle(reportTitle);

		await generateCsv(index, uniqueFileName).then(async () => {
			console.log('Create session in cognos');
			await createCognosSession(async (sessionCode) => {
				console.log('Main reporting param', sessionCode);
				var myCognosApi = new CognosApi({
					cognosRootURL:
						'https://us-south.dynamic-dashboard-embedded.cloud.ibm.com/daas/',
					sessionCode: sessionCode,
					initTimeout: 10000,
					node: document.getElementById('ddeDashboard'),
				});

				setCognosApi(myCognosApi);

				try {
					await myCognosApi.initialize();

					console.log('API created successfully.');

					createDashboard(
						myCognosApi,
						uniqueFileName,
						reportName,
						(dashboardApi) => {
							console.log(
								'This is the dashboard API',
								dashboardApi
							);
							setDashboardAPI(dashboardApi);
						}
					);
					setLoading(false);

					// await openDashboard(myCognosApi, dashboardSpec);
				} catch (e) {
					console.log(
						'Unable to initialize API instance: ' + e.message
					);
					setLoading(false);
					throw e;
				}

				console.log('This api', myCognosApi.dashboard);
			});
		});
	};

	const handleViewReport = async (reportName, index, reportTitle) => {
		console.log('Running handleGenerateReport... ', index, reportName);
		setLoading(true);
		var currentUser = firebase.auth().currentUser.uid;
		var unixTime = dayjs().unix();
		var uniqueFileName = `${reportName}_${currentUser}_${unixTime}`;

		setReportUniqueName(uniqueFileName);
		setReportTitle(reportTitle);

		console.log('uniqueFileName', uniqueFileName);
		var retryCount = 0;

		await generateCsv(index, uniqueFileName).then(async () => {
			console.log('Create session in cognos');
			await createCognosSession(async (sessionCode) => {
				console.log('Main reporting param', sessionCode);
				var myCognosApi = new CognosApi({
					cognosRootURL:
						'https://us-south.dynamic-dashboard-embedded.cloud.ibm.com/daas/',
					sessionCode: sessionCode,
					initTimeout: 10000,
					node: document.getElementById('ddeDashboard'),
				});

				setCognosApi(myCognosApi);

				try {
					await myCognosApi.initialize();

					console.log('API created successfully.');

					await getCsvUrl(uniqueFileName).then(async (url) => {
						console.log('PUBLIC URL', url);
						await openDashboard(
							myCognosApi,
							index,
							url,
							reportName,
							uniqueFileName
						).then(() => {
							setLoading(false);
						});
					});
				} catch (e) {
					console.log(
						'Unable to initialize API instance: ' + e.message
					);
					retryCount++;
					if (retryCount < 3) {
						generateCsv(index, uniqueFileName);
					}
					setLoading(false);
					throw e;
				}

				console.log('This api', myCognosApi.dashboard);
			});
		});
	};

	return (
		<>
			<div className={styles.category_wrapper}>
				<div className={styles.category_header}>{title}</div>
				<hr className={styles.separator} />
				<div className={styles.category_item_parent}>
					{filteredReports?.length > 0 ? (
						<>
							{filteredReports?.map((report, index) => {
								return (
									<ReportCategoryItem
										icon={String(report?.icon)}
										title={report?.name}
										key={index}
										reportIndex={report.index}
										reportId={report.id}
										reportName={report.name}
										handleGenerateReport={
											handleGenerateReport
										}
										handleViewReport={handleViewReport}
									/>
								);
							})}
						</>
					) : (
						<div className={styles.error_placeholder}>
							No results found.
						</div>
					)}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	reports: state.reporting.reports,
});

export default connect(mapStateToProps, { setLoading })(ReportCategory);
